import Link from "next/link";
import styled from "styled-components";

const TidalDashboardServerProdiverSelectWrapper = styled.div`
  width: 100%;
`;

const TidalDashboardServerProdiverSelectWrapperLabel = styled.p`
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  text-align: left;
  margin-bottom: 8px;
  color: ${(props) => props.theme.colors.text[0]};
  position: relative;
  width: fit-content;
  & > span {
    position: absolute;
    right: -10px;
    bottom: 4px;
    color: ${(props) => props.theme.colors.text[3]};
  }
`;

const TidalDashboardServiceProvidersRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 0 10px;
`;

const TidalDashboardServerProviderCard = styled.div<{
  isSelected: boolean;
  isAdded: boolean;
}>`
  background-color: ${(props) =>
    !props.isSelected
      ? props.theme.colors.secondary
      : props.theme.colors.background};
  height: 71px;
  width: 100%;
  border-radius: 10px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  cursor: ${(props) => (props.isAdded ? "pointer" : "not-allowed")};
  border: ${(props) =>
    props.isSelected ? `1px solid ${props.theme.colors.accent}` : "none"};
  box-shadow: ${(props) =>
    props.isSelected ? "0px 5px 13px rgba(33, 35, 41, 0.1)" : ""};
  transition: 0.3s all ease-in-out;
  & > p {
    font-size: 10px;
    color: blue;
    cursor: pointer;
  }
`;

interface ITidalDashboardServerProdiverSelect {
  label: string;
  items: any[];
  isRequired?: boolean;
  onSelect: (item: any) => void;
}

const TidalDashboardServerProdiverSelect = ({
  label,
  items,
  isRequired,
  onSelect,
}: ITidalDashboardServerProdiverSelect): JSX.Element => {
  return (
    <TidalDashboardServerProdiverSelectWrapper>
      <TidalDashboardServerProdiverSelectWrapperLabel>
        {label}
        {isRequired && <span>*</span>}
      </TidalDashboardServerProdiverSelectWrapperLabel>
      <TidalDashboardServiceProvidersRow>
        {items.map((item: any) => (
          <TidalDashboardServerProviderCard
            isAdded={item.isAdded}
            isSelected={item.isSelected}
            onClick={() => item.isAdded && onSelect(item)}
          >
            {item.icon}
            {!item.isAdded && (
              <Link href="/tidal-dashboard/servers/settings">
                <p>Add credentials</p>
              </Link>
            )}
          </TidalDashboardServerProviderCard>
        ))}
      </TidalDashboardServiceProvidersRow>
    </TidalDashboardServerProdiverSelectWrapper>
  );
};

export default TidalDashboardServerProdiverSelect;
